const data = [
	{
		MOU: `Signed Mou with Hackers Era a Network security company`,
	},
	{
		MOU: `Signed Mou with Kasnet Technologies Pvt. Ltd. a software development 
		company`,
	},
	{
		MOU: `Signed Mou with “ Heartfullness Institute” a globally recognized yoga & 
		meditation institute
		`,
	},
];

export default data;
